export default __webpack_public_path__ + "static/media/application-img-05.042eafb4.jpg";